import { Star } from "lucide-react";

export default function ReviewCard({ avis }) {
  return (
    <div className="bg-white border border-[#062133]/10 rounded-lg p-6 transition-all hover:-translate-y-1 hover:shadow-md" data-testid={`review-card-${avis.id || avis.prenom}`}>
      <div className="flex gap-0.5 mb-3">
        {Array.from({ length: 5 }, (_, i) => (
          <Star key={i} size={16} className={i < avis.note ? "fill-amber-400 text-amber-400" : "text-slate-200"} />
        ))}
      </div>
      <p className="text-[#062133] text-sm leading-relaxed mb-4 line-clamp-4">&laquo; {avis.commentaire} &raquo;</p>
      <div className="flex items-center justify-between">
        <span className="font-semibold text-sm text-[#062133]">{avis.prenom}, {avis.ville}</span>
        <span className="text-xs text-[#062133]/60 bg-[#F4F6F8] px-2 py-1 rounded">{avis.service}</span>
      </div>
    </div>
  );
}
